module.exports = __webpack_public_path__ + "img/arround-left.dcd772f0.svg";